/* ••[1]••••••••••••••••••••••••• Provider.ts •••••••••••••••••••••••••••••• */

import FetchSettings from "../interfaces/FetchSettings";

export default abstract class Provider {
  protected async request<T>(url: string, settings: FetchSettings): Promise<T>;
  protected async request<Response>(
    url: string,
    settings: FetchSettings,
    returnRawResponse: boolean
  ): Promise<Response>;
  protected async request(
    url: string,
    settings: FetchSettings,
    returnRawResponse = false
    // eslint-disable-next-line
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      fetch(url, settings)
        .then((response) => {
          if (returnRawResponse) {
            resolve(response);
          } else {
            return response.json();
          }
        })
        .then((json) => {
          resolve(json);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
